import { render, staticRenderFns } from "./FccBotoes.vue?vue&type=template&id=596da78c"
import script from "./FccBotoes.vue?vue&type=script&lang=js"
export * from "./FccBotoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports